import {useState} from 'react'
import cleanJsonString from 'tool/cleanJsonString.js'
import {Row, Col} from 'react-bootstrap'
import {descriptionStyle} from './ReqRes.js'
import Note from './Note.js'
import ReactJson from 'react-json-view'
import IconExpandContract from './IconExpandContract.js'
import HeaderParameterTable from './HeaderParameterTable.js'
import {StatusCodeBadge, statusCodeBadgeColor} from './Badges.js'
import './ResponseExample.sass'

const ResponseExample = (props) => {
    const origHeader = props.originalRequest?.header?.length > 0 ? props.originalRequest.header : []
    let origBodyString = props.originalRequest?.body?.raw ? props.originalRequest.body?.raw : null
    origBodyString = cleanJsonString(origBodyString)

    const [showOriginalRequest, _setShowOriginalRequest] = useState(false)
    const toggleOriginalRequest = () => _setShowOriginalRequest(!showOriginalRequest)


    const header = props.header?.length > 0 ? props.header : []
    let bodyString = props.body ? props.body : null
    bodyString = cleanJsonString(bodyString)

    const [showResponse, _setShowResponse] = useState(false)
    const toggleRequest = () => _setShowResponse(!showResponse)

    const borderStyle = {borderBottom: 'solid thin var(--gray-dark)'}
    return(
        <Col xs={12} className="response_example-container mb-2 pb-3" style={{border: `solid thin ${statusCodeBadgeColor(props?.code)}`}}>
            <div>
                <Row className="response_example-main_title cursor-pointer d-flex align-items-center pt-2">
                    <Col xs="auto" className="d-flex align-items-center pb-1">
                        <StatusCodeBadge value={props?.code}/>
                    </Col>
                    <Col className="d-flex align-items-center pl-0">
                        <h5>{props.title ? props.title : 'Example'}</h5>
                    </Col>
                </Row>
            </div>
            
            <Col xs={12} onClick={toggleOriginalRequest}>
                <Row className="cursor-pointer d-flex align-items-center pt-1" style={borderStyle}>
                    <Col className="d-flex align-items-center pl-0">
                        <h5>Request</h5>
                    </Col>
                    <Col xs="auto" className="d-flex align-items-center">
                        <IconExpandContract value={!showOriginalRequest} />
                    </Col>
                </Row>
            </Col>
            <div className={`${showOriginalRequest?'show':'hide'}`}>
                <Col xs={12} className="mt-2">
                    <h5 className="response_example-_title">Header</h5>
                    <Col xs={12} style={descriptionStyle}>
                        <HeaderParameterTable header={origHeader}/>
                    </Col>
                </Col>
                <Col xs={12} className="mt-3  pb-4">
                    <h5>Body</h5>
                    <Col xs={12} style={descriptionStyle}>
                        {origBodyString ? <ReactJson src={origBodyString} displayDataTypes={false} name={false}/> : <Note>Empty</Note>}
                    </Col>
                </Col>
            </div>

            <Col xs={12} onClick={toggleRequest}>
                <Row className="cursor-pointer d-flex align-items-center pt-1" style={borderStyle}> 
                    <Col className="d-flex align-items-center pl-0">
                        <h5>Response</h5>
                    </Col>
                    <Col xs="auto" className="d-flex align-items-center">
                        <IconExpandContract value={!showResponse} />
                    </Col>
                </Row>
            </Col>
            <div className={`${showResponse?'show':'hide'}`}>
                {props.hideResponseHeader
                    ?   null
                    :   <Col xs={12} className="mt-2">
                            <h5>Header</h5>
                            <Col xs={12} style={descriptionStyle}>
                                <HeaderParameterTable header={header}/>
                            </Col>
                        </Col>
                    }
                <Col xs={12} className="mt-3  pb-4">
                    <h5>Body</h5>
                    <Col xs={12} style={descriptionStyle}>
                        {bodyString ? <ReactJson src={bodyString} displayDataTypes={false} name={false}/> : <Note>Empty</Note>}
                    </Col>
                </Col>
            </div>
        </Col>
    )
}

ResponseExample.defaultProps = {
    hideResponseHeader: false
}
export default ResponseExample
